module.exports = __webpack_public_path__ + "static/logo-8c211f7127b1fa0ccc52be5aa86ca30f.png";